export default function initAnalytics() {
  if (typeof analytics !== 'undefined' || typeof window === 'undefined' && window.analytics) {}
}